import './App.scss';
import React, { createContext, useEffect, useMemo } from 'react';
import WebFont from 'webfontloader';
import { Provider } from 'react-redux';
import store from './redux/store/store';
import { ToastContainer } from 'react-toastify';
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton, Stack } from '@mui/material';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import RootNavigation from './navigation/RootNavigation';
import getDesignTokens from './utils/theme';
import CreateUnionRegistryAccount from './pages/Layouts/CreateUnionRegistryAccount';

const ColorModeContext = createContext();

function App() {
  const [mode, setMode] = React.useState('light');

  useEffect(() => {
    WebFont.load({
      google: {
        families: [
          'Roboto',
          'Roboto:Thin',
          'Roboto:Light',
          'Roboto:Regular',
          'Roboto:Medium',
          'Roboto:Bold',
          // 'Open Sans', 'Open Sans:Thin', 'Open Sans:Light', 'Open Sans:Regular', 'Open Sans:Medium', 'Open Sans:Bold',
          // 'Noto Sans', 'Noto Sans:Bold', 'Noto Sans:Thin', 'Noto Sans:Light', 'Noto Sans:Regular', 'Noto Sans:Medium'
        ],
      },
    });
  }, []);

  const colorMode = useMemo(
    () => ({
      // The dark mode switch would invoke this method
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );

  // Update the theme only if the mode changes
  const theme = useMemo(() => createTheme(getDesignTokens(mode)), [mode]);
  const CloseButton = ({ closeToast }) => (
    <IconButton
      disableRipple
      style={{ padding: '0' }}
      onClick={closeToast}
    >
      <ClearIcon style={{ transform: 'scale(1)', color: '#fff' }} />
    </IconButton>
  );

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <RootNavigation />
          <ToastContainer
            hideProgressBar={true}
            pauseOnFocusLoss={false}
            closeButton={CloseButton}
            icon={false}
          />
        </Provider>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
}

export default App;
